module.exports = __webpack_public_path__ + "img/refresh-ccw-03.273f211a.svg";